import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'image-block',
  templateUrl: './image-block.component.html',
  styleUrls: ['./image-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ImageBlockComponent {
  @Input() imgblock: any;

  color: string;

  private _title: string;
  private _display: string;
  private _height = 'auto';
  private _width: string;
  private _maxWidth = '100%';
  private _align: string;
  private _alt: string;
  private _border: string;
  private _filter: string;
  private _opacity: number;
  private _radius: string;
  private _transform: string;
  private _marginLeft: string;
  private _marginRight: string;

  constructor() {}

  getMyStyles() {
    const result = {
      color: this.imgblock.color ? this.imgblock.color : this._title,
      display: this.imgblock.display ? this.imgblock.display : this._display,
      height: this.imgblock.height ? this.imgblock.height : this._height,
      width: this.imgblock.width ? this.imgblock.width : this._width,
      'max-width': this.imgblock.maxWidth ? this.imgblock.maxWidth : this._maxWidth,
      align: this.imgblock.align ? this.imgblock.align : this._align,
      alt: this.imgblock.alt ? this.imgblock.alt : this._alt,
      border: this.imgblock.border ? this.imgblock.border : this._border,
      filter: this.imgblock.filter ? this.imgblock.filter : this._filter,
      opacity: this.imgblock.opacity ? this.imgblock.opacity : this._opacity,
      'border-radius': this.imgblock.radius ? this.imgblock.radius : this._radius,
      transform: this.imgblock.transform ? this.imgblock.transform : this._transform,
      'margin-left': this.imgblock.marginLeft ? this.imgblock.marginLeft : this._marginLeft,
      'margin-right': this.imgblock.marginRight ? this.imgblock.marginRight : this._marginRight,
    };
    return result;
  }

  openImageUrl(url) {
    if (url && url !== '' && url !== 'https://') {
      window.open(url);
    }
  }
}
